
export const ShareOrigin = () => {
  return window.SHARE_ORIGIN
}